{
    "RangeCombo_Search_Placeholder": "Zoeken...",
    "NAME": "RangeComboLanguage",
    "Validation_Generic_Error_Message": "Er zijn momenteel 1 of meer fouten gedetecteerd",
    "Validation_Generic_Error_Max_Entries": "U hebt het maximale aantal inzendingen bereikt\/overschreden."
}